let Carousel = {
	init: function(speed, uniqueId){
		const sliderSelector = '#' + uniqueId + '-slick-slider';
		const navSelector = '#' + uniqueId + '-slider-nav';

		jQuery(sliderSelector).slick({
			dots: true,
			arrows: true,
			adaptiveHeight: true,
			prevArrow: '<i class="fa fa-chevron-left slick-prev"></i>',
			nextArrow: '<i class="fa fa-chevron-right carousel-rev-slick-next slick-next"></i>', 
			appendArrows: navSelector,
			appendDots: navSelector,
			autoplay: true,
			autoplaySpeed: speed,
			lazyLoad: 'ondemand',
		});

		jQuery(navSelector + ' .carousel-rev-slick-next').detach().insertAfter(navSelector + ' .slick-dots');
		jQuery('#' + uniqueId + '-slick-wrapper').removeAttr('style');
	}
}